var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8223 0.00146484C14.9642 0.00167436 18.3223 3.35946 18.3223 7.50146C18.3218 12.8935 10.8223 20.0015 10.8223 20.0015C10.8223 20.0015 3.3227 12.8935 3.32227 7.50146C3.32227 3.35933 6.68013 0.00146484 10.8223 0.00146484ZM10.8223 3.75146C8.7512 3.75146 7.07227 5.4304 7.07227 7.50146C7.07252 9.57232 8.75135 11.2515 10.8223 11.2515C12.893 11.2513 14.572 9.57219 14.5723 7.50146C14.5723 5.43053 12.8932 3.75167 10.8223 3.75146Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.1f0621c51f93ea855fe71611ceb85b9e.svg";
export { ForwardRef as ReactComponent };